import React from 'react';
import { Sparkles, Baby } from 'lucide-react';

const FORMAT = (d) => {
  if (!d) return null;
  try {
    return new Date(`${String(d).slice(0, 10)}T00:00:00`).toLocaleDateString('en-IN',
      { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return String(d).slice(0, 10); }
};

const SOURCE_TEXT = {
  sales_link: 'Paid via payment link',
  elite_addon_link: 'Included with Elite link',
  ops_purchase: 'Paid via payment link',
  self_serve: 'Paid in app / LMS',
  lms_complimentary: 'LMS complimentary access',
  complimentary: 'Complimentary access',
  admin_grant: 'Granted by LMS admin',
  free_trial: 'Free trial access',
};

const STATUS_TEXT = {
  active: 'Activated',
  trial: 'Trial access',
  expired: 'Expired',
  cancelled: 'Cancelled',
  revoked: 'Revoked by LMS',
  refunded: 'Refunded',
};

const Row = ({ icon: Icon, title, entry, testid }) => {
  const status = entry?.status || null;
  const active = status === 'active' || status === 'trial';
  const ended = !!status && !active;
  return (
    <div className="flex items-start gap-2" data-testid={testid}>
      <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${active ? 'text-teal-600' : 'text-slate-400'}`} />
      <div className="min-w-0">
        <p className="text-xs text-slate-500">{title}</p>
        <p className={`text-sm font-medium ${active ? 'text-teal-700' : ended ? 'text-rose-700' : 'text-slate-500'}`}
           data-testid={`${testid}-value`}>
          {!status ? 'Not activated'
            : STATUS_TEXT[status] || status.charAt(0).toUpperCase() + status.slice(1)}
        </p>
        {active && entry?.expires_at && (
          <p className="text-xs text-slate-500" data-testid={`${testid}-expiry`}>
            Expires {FORMAT(entry.expires_at)}
          </p>
        )}
        {active && !entry?.expires_at && (
          <p className="text-xs text-slate-400" data-testid={`${testid}-expiry`}>No expiry on record</p>
        )}
        {ended && entry?.expires_at && (
          <p className="text-xs text-slate-500" data-testid={`${testid}-expiry`}>
            Ended {FORMAT(entry.expires_at)}
          </p>
        )}
        {entry?.source && (
          <p className="text-xs text-slate-400">{SOURCE_TEXT[entry.source] || entry.source}</p>
        )}
      </div>
    </div>
  );
};

export const AddonStatus = ({ lead }) => {
  const products = Array.isArray(lead?.products) ? lead.products : [];
  const find = (name) => products.find((p) => p?.product === name) || null;
  return (
    <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 bg-slate-50 border border-slate-200 rounded-lg p-3"
         data-testid="addon-status-section">
      <Row icon={Sparkles} title="SoulAI Status" entry={find('soulai_coach')} testid="soulai-status" />
      <Row icon={Baby} title="Baby Tracker Status" entry={find('baby_tracker')} testid="babytracker-status" />
    </div>
  );
};
